import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-guide-enterprise-mdm',
  templateUrl: './guide-enterprise-mdm.component.html',
  styleUrls: ['./guide-enterprise-mdm.component.scss']
})
export class GuideEnterpriseMdmComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
